import "core-js/modules/es6.regexp.split";

const parseHash = hash => hash.split('&').reduce((acc, item) => {
  const currentAcc = acc;
  const parts = item.split('=');
  [, currentAcc[parts[0]]] = parts;
  return currentAcc;
}, {});

export default parseHash;